import { ENTRY_BASE_URL } from '@api/EntryApi';
import { axios } from '@lib/axios';

import {
    AudioRecordPreviewData,
    EntryAudioRecordCreateParams,
    EntryAudioRecordData,
    EntryAudioRecordListQuery,
    EntryAudioRecordUploadStateForm,
} from 'chaika-frontend-types/frontend-cms';

export class EntryAudioRecordsApi {
    public static async findRecords(params: EntryAudioRecordListQuery): Promise<EntryAudioRecordData[]> {
        const res = await axios.get(`${ENTRY_BASE_URL}/audio-record`, {
            params,
        });

        return res.data;
    }

    public static async createRecord(entryId: string, entryAudioRecord: EntryAudioRecordCreateParams): Promise<void> {
        await axios.post(`${ENTRY_BASE_URL}/${entryId}/audio-record`, { entryAudioRecord });
    }

    public static async retryRecord(entryId: string, audioRecordId: string): Promise<void> {
        await axios.post(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/retry`);
    }

    public static async syncUploadState(
        entryId: string,
        audioRecordId: string,
        uploadState: EntryAudioRecordUploadStateForm,
    ): Promise<void> {
        await axios.put(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/upload-state`, uploadState);
    }

    public static async deleteRecord(entryId: string, recordId: string): Promise<void> {
        await axios.delete(`${ENTRY_BASE_URL}/${entryId}/audio-record/${recordId}`);
    }

    public static async getTranscriptionPreview(
        entryId: string,
        audioRecordId: string,
    ): Promise<AudioRecordPreviewData> {
        const res = await axios.get(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/preview`, {
            skipForbiddenPopup: true,
        });
        return res.data;
    }

    public static async addTranscriptionToEntry(entryId: string, audioRecordId: string): Promise<void> {
        await axios.put(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/add`);
    }

    public static async addItem(entryId: string, audioRecordId: string, itemId: string, text?: string): Promise<void> {
        await axios.put(`${buildItemUrl(entryId, audioRecordId, itemId)}/add`, { text });
    }

    public static async excludeItem(entryId: string, audioRecordId: string, itemId: string): Promise<void> {
        await axios.put(`${buildItemUrl(entryId, audioRecordId, itemId)}/exclude`);
    }

    public static async restoreItem(entryId: string, audioRecordId: string, itemId: string): Promise<void> {
        await axios.put(`${buildItemUrl(entryId, audioRecordId, itemId)}/restore`);
    }

    public static async editItem(entryId: string, audioRecordId: string, itemId: string, text: string): Promise<void> {
        await axios.put(`${buildItemUrl(entryId, audioRecordId, itemId)}/edit`, { text });
    }
}

function buildItemUrl(entryId: string, audioRecordId: string, itemId: string): string {
    return `${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/items/${encodeURIComponent(itemId)}`;
}
